export default __webpack_public_path__ + "static/media/info.d893cde9.svg";